import { useState, useEffect, useRef } from "react";
import InlineDescription from "./InlineDescription";
const InputFileMultiple = (props) => {
	const {
		id,
		label,
		name,
		required = false,
		multiple = false,
		placeholder,
		accept = "*",
		description,
		handleMultipleFiles,
		notEmptyMessage,
		maxFileSizeErrorMessage,
		acceptErrorMessage,
		modifier,
		inlineErrors,
		imageLocation,
		isMobileView,
		maxSize,
		setFileRemoved,
		fileRemoved,
	} = props;
	const decorativeImage = "sparkles.png";
	const mainClass = "help-input-file-multiple";
	const modifierClass = modifier ? ` ${mainClass}--${modifier}` : "";
	const strAccept = Array.isArray(accept) ? accept?.join(",") : accept;
	const [hasError, setHasError] = useState();
	const dragContainerRef = useRef(null);
	const inputFileRef = useRef(null);

	useEffect(() => {
		if (fileRemoved) {
			setFileRemoved(false);
			inputFileRef.current.value = "";
		}
	}, [fileRemoved, setFileRemoved]);

	useEffect(() => {
		if (!!inlineErrors?.[name]) {
			setHasError(true);
		} else {
			setHasError(false);
		}
	}, [inlineErrors, name]);

	useEffect(() => {
		const dragRefElement = dragContainerRef?.current;
		["dragenter", "dragover", "dragleave", "drop"].forEach((evt) => {
			dragRefElement.addEventListener(evt, preventDefaults, false);
			return () => dragRefElement.removeEventListener("drop", handleDrop);
		});
		dragRefElement.addEventListener("keypress", handleEnter);
		dragRefElement.addEventListener("drop", handleDrop, false);

		return () => {
			dragRefElement.removeEventListener("keypress", handleEnter);
			dragRefElement.removeEventListener("drop", handleDrop);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!name) return null;
	const preventDefaults = (e) => {
		e.preventDefault();
		e.stopPropagation();
	};
	const handleEnter = (evt) => {
		if (evt.key === "Enter") {
			inputFileRef?.current.click();
		}
	};

	const handleDrop = (e) => {
		let dt = e.dataTransfer;
		let files = dt.files;
		handleMultipleFiles &&
			handleMultipleFiles(
				id,
				required,
				notEmptyMessage,
				maxFileSizeErrorMessage,
				accept,
				acceptErrorMessage,
				multiple,
				maxSize,
				files,
				setHasError
			);
	};

	return (
		<div ref={dragContainerRef} className={`${mainClass}${modifierClass} `}>
			{label && (
				<label className={`${mainClass}__label`} htmlFor={id}>
					<div className={`${mainClass}__label--image`}>
						<img
							className={`${mainClass}__label__image`}
							src={`${imageLocation}/${decorativeImage}`}
							loading="lazy"
							alt=""
						/>
					</div>

					<div
						className={`${mainClass}__label--text`}
						dangerouslySetInnerHTML={{
							__html: label && `${label}${required ? "*" : ""}`,
						}}
					></div>
				</label>
			)}
			{description?.modalContent && (
				<InlineDescription
					{...description}
					isMobileView={isMobileView}
					position="top"
				/>
			)}
			<input
				ref={inputFileRef}
				className={`${mainClass}__input${
					hasError ? ` ${mainClass}__input--error` : ""
				}`}
				id={id}
				type="file"
				name={name}
				placeholder={placeholder}
				accept={strAccept}
				required={required}
				aria-required={required}
				aria-describedby={`${id}_error`}
				multiple
				onChange={(e) => {
					handleMultipleFiles &&
						handleMultipleFiles(
							id,
							required,
							notEmptyMessage,
							maxFileSizeErrorMessage,
							accept,
							acceptErrorMessage,
							multiple,
							maxSize,
							e.target.files,
							setHasError
						);
				}}
			/>
			{description?.text && (
				<InlineDescription
					{...description}
					isMobileView={isMobileView}
					position="bottom"
				/>
			)}
		</div>
	);
};

export default InputFileMultiple;
